export default __webpack_public_path__ + "static/media/help-woman-blue.d7eceeed.svg";